<div *ngIf="sessionData" class="mat-typography">
  <div class="header-container white-text w-full h-20 sm:h-24 p-0
border-top-edges-rounded pl-2 pr-2 md:pl-4 md:pr-4 flex items-center" *ngIf="!routeError && sessionData.sessionDisplayInformation; else loading" [ngStyle]="{'background-color': colorScheme}">
    <div class="header-child w-1/2">
<!--      text-md sm:text-3xl-->
      <p class="w-full m-0 mb-0 header-theme-typography" *ngIf="!mobile" style="font-size: 16px; margin-bottom: 6px !important;" >{{ headerData["product"] }}</p>
      <p class="w-full m-0 mb-0 header-theme-typography" *ngIf="mobile" style="font-size: 14px; margin-bottom: 6px !important;" >{{ mobileLabel }}</p>
      <!--<button *ngIf="sessionData.orderItems.length > 0" (click)="showOrderDetails()" style="min-height: 25px;" class="bg-transparent hover:bg-gray-400 text-xs sm:text-md text-white-500 hover:text-white py-0 px-2 border border-white-500 hover:border-transparent rounded">
        View Order Details
      </button>-->
      <p *ngIf="!expanded" class="font-hairline mt-1 mb-0 cursor-pointer" [style.fontSize]="mobile ? '14px' : '14px'"
         (click)="expanded = !expanded">
        {{ sessionData.sessionDisplayInformation.merchantReference | slice:0:40 }}
        <span *ngIf="sessionData.sessionDisplayInformation.merchantReference.length > 40"> ...</span>
      </p>
      <div *ngIf="expanded" class="absolute left-0 right-0 bg-white rounded-lg shadow-lg p-2 cursor-pointer z-10" (click)="expanded = !expanded">
        <p class="font-hairline mt-1 mb-0 text-gray-700" [style.fontSize]="mobile ? '14px' : '14px'">
          {{ sessionData.sessionDisplayInformation.merchantReference }}
        </p>
      </div>
    </div>
    <div *ngIf="sessionData.sessionDisplayInformation.merchantLogo">
      <img [src]="sessionData.sessionDisplayInformation.merchantLogo" class="ml-2" [ngStyle]="{'width': mobile ? '93px' : '93px'}">
    </div>
    <div *ngIf="sessionData.flow != 'CARD_VERIFICATION'" class="currency-container w-1/2 flex justify-end" [ngStyle]="{'display': mobile ? 'flex' : '', 'flex-direction': mobile ? 'column' : '', 'justify-content': mobile ? 'space-between' : '', 'align-items': mobile ? 'flex-end' : 'center'}">
      <p class="text-md m-2">{{ sessionData.sessionDisplayInformation.currencyCode }}</p> <p class="text-4xl lg:text-5xl mb-0">{{ sessionData.sessionDisplayInformation.amount.toFixed(2) }}</p>
    </div>
  </div>
  <div
    *ngIf="!sessionData.sessionDisplayInformation"
    class="w-full flex items-center pl-3"
    style="
      background-color: rgb(179 211 127);
      height: 64px;
    "
    [ngStyle]="{'border-top-left-radius': mobile ? '0px' : '19px', 'border-top-right-radius': mobile ? '0px' : '19px'}"
  >
    <img
      src="assets/icons/Icons/Group.png"
      style="height: 40px;"
    />
  </div>
</div>

<div *ngIf="!sessionData">
  <div
    class="w-full flex items-center pl-3"
    style="
      height: 64px;
      background-color: #272727;
    "
    [ngStyle]="{'border-top-left-radius': mobile ? '0px' : '19px', 'border-top-right-radius': mobile ? '0px' : '19px'}"
  >
    <img
      src="assets/icons/Icons/Group.png"
      style="height: 40px;"
    />
  </div>
</div>





<ng-template #loading *ngIf="!routeError">
  <span class="p-4">Loading order details...</span>
</ng-template>
